import factMethods from './view_case_details_fact_methods';
import loadingMethods from './view_case_details_loading_methods';
import verificationMethods from './view_case_details_verification_methods';

export default {
  ...factMethods,
  ...loadingMethods,
  ...verificationMethods,
};
